import * as userServices from './user';
import * as publicServices from './public';
import * as investorsServices from './investors';


export default {userServices, publicServices, investorsServices};
